import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Search, Map, User, Plus } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
interface NavItem {
  to: string;
  label: string;
  icon: React.ElementType;
}
const items: NavItem[] = [{
  to: '/',
  label: 'Home',
  icon: Home
}, {
  to: '/explore',
  label: 'Explore',
  icon: Search
}, {
  to: '/map',
  label: 'Map',
  icon: Map
}, {
  to: '/login',
  label: 'Account',
  icon: User
}];
export const MobileNav = () => {
  const {
    pathname
  } = useLocation();
  const {
    isAuthenticated
  } = useAuth();
  const isActive = (to: string) => to === '/' ? pathname === '/' : pathname.startsWith(to);
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 pointer-events-none" data-id="element-303">
      {/* Floating pill */}
      <div className="mx-4 mb-4 pointer-events-auto" data-id="element-304">
        <nav className="relative bg-white/95 backdrop-blur-lg border border-neutral-200 shadow-[0_8px_30px_rgba(0,0,0,0.12)] rounded-2xl px-2 py-2 flex items-center justify-between" aria-label="Mobile navigation" data-id="element-305">
          {isAuthenticated ? <>
              {/* Left two items */}
              <div className="flex flex-1 justify-around" data-id="element-306">
                {items.slice(0, 2).map(item => <NavButton key={item.to} item={item} active={isActive(item.to)} data-id="element-307" />)}
              </div>

              {/* Center FAB — List Property (logged-in only) */}
              <Link to="/list-property" aria-label="List a property" className="relative -mt-8 mx-1 shrink-0" data-id="element-308">
                <motion.div whileTap={{
              scale: 0.9
            }} className="w-14 h-14 rounded-2xl bg-secondary text-white flex items-center justify-center shadow-glow ring-4 ring-white" data-id="element-309">
                  <Plus size={26} strokeWidth={2.5} data-id="element-310" />
                </motion.div>
              </Link>

              {/* Right two items */}
              <div className="flex flex-1 justify-around" data-id="element-311">
                {items.slice(2).map(item => <NavButton key={item.to} item={item} active={isActive(item.to)} data-id="element-312" />)}
              </div>
            </> :
        // Logged-out: evenly spaced tabs, no List Property FAB
        <div className="flex flex-1 justify-around" data-id="element-313">
              {items.map(item => <NavButton key={item.to} item={item} active={isActive(item.to)} data-id="element-314" />)}
            </div>}
        </nav>
      </div>
    </div>;
};
const NavButton = ({
  item,
  active
}: {
  item: NavItem;
  active: boolean;
}) => {
  const Icon = item.icon;
  return <Link to={item.to} aria-label={item.label} aria-current={active ? 'page' : undefined} className="relative flex flex-col items-center justify-center gap-0.5 px-3 py-1.5 min-w-[56px]" data-id="element-315">
      <motion.div whileTap={{
      scale: 0.85
    }} className={`flex items-center justify-center transition-colors ${active ? 'text-secondary' : 'text-text-light'}`} data-id="element-316">
        <Icon size={22} strokeWidth={active ? 2.4 : 2} data-id="element-317" />
      </motion.div>
      <span className={`text-[10px] font-semibold transition-colors ${active ? 'text-secondary' : 'text-text-light'}`} data-id="element-318">
        {item.label}
      </span>
      {active && <motion.div layoutId="mobileNavIndicator" className="absolute -top-0.5 w-1 h-1 rounded-full bg-secondary" transition={{
      type: 'spring',
      stiffness: 500,
      damping: 30
    }} data-id="element-319" />}
    </Link>;
};